import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';

const DEFAULT_IMAGE = 'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_640.png';

const UserList = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePlans, setActivePlans] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [subchildCategories, setSubchildCategories] = useState([]);
  const [displayCount, setDisplayCount] = useState(20);

  const isLoggedIn = localStorage.getItem('user') !== null;
  const userss = isLoggedIn ? JSON.parse(localStorage.getItem('user')) : null;

  const [filters, setFilters] = useState({
    name: '',
    userType: '',
    contact_no: '',
    city: '',
    state: '',
    pincode: '',
    parent_category_id: '',
    child_category_id: '',
    subchild_category_id: '',
    status: ''
  });

  const [sortConfig, setSortConfig] = useState({
    key: 'created_at',
    direction: 'desc'
  });

  const fetchCategories = async () => {
    try {
      const [catRes, childRes, subchildRes] = await Promise.all([
        api.get('/categories'),
        api.get('/child-categories'),
        api.get('/subchild-categories'),
      ]);

      setCategories(catRes.data || []);
      setChildCategories(childRes.data || []);
      setSubchildCategories(subchildRes.data || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchActivePlans = async () => {
    try {
      const response = await api.get('/user/active-plans');
      setActivePlans(response.data.plans || []);
    } catch (error) {
      console.error('Error fetching active plans:', error);
      setActivePlans([]);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const userTypeFromUrl = searchParams.get("type");

    if (userTypeFromUrl) {
      setFilters(prev => ({
        ...prev,
        userType: userTypeFromUrl
      }));
    }
  }, [location.search]);
  
  useEffect(() => {
  const handleContextMenu = (e) => e.preventDefault();
  const handleKeyDown = (e) => {
    if (e.key === "F12") e.preventDefault();
    if (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) e.preventDefault();
    if (e.ctrlKey && (e.key === "U" || e.key === "S")) e.preventDefault();
  };
  document.addEventListener("contextmenu", handleContextMenu);
  document.addEventListener("keydown", handleKeyDown);
  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
    document.removeEventListener("keydown", handleKeyDown);
  };
}, []);


  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = {};

      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params[key] = filters[key];
        }
      });

      if (filters.userType) {
        params.type = filters.userType;
      }

      const response = await api.get('/users', { params });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to fetch users');
      }

      setUsers(Array.isArray(response.data.users) ? response.data.users : []);

    } catch (err) {
      console.error('Error fetching users:', err);
      setError(err.message);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const hasActivePlan = activePlans.some(plan => plan.user_id === userss?.id);
const loggedInUserType = userss?.user_type?.toLowerCase();
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleApplyFilters = () => {
    fetchUsers();
  };

  const handleResetFilters = () => {
    setFilters({
      name: '',
      userType: '',
      contact_no: '',
      city: '',
      state: '',
      pincode: '',
      parent_category_id: '',
      child_category_id: '',
      subchild_category_id: '',
      status: ''
    });
    fetchUsers();
  };

  useEffect(() => {
    fetchUsers();
    fetchActivePlans();
    fetchCategories();
  }, [filters, sortConfig]);

  useEffect(() => {
    const handleScroll = () => {
      const bottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 200;
      if (bottom) {
        setDisplayCount(prev => prev + 20);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sortedUsers = useMemo(() => {
    let sorted = [...users];

    sorted.sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      if (sortConfig.key === 'created_at') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      } else if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    return sorted;
  }, [users, sortConfig]);

    /* ===================== PROTECTED FIELD HELPER ===================== */
const renderProtectedValue = (value, viewedUserType, options = {}) => {
  if (!value) return <span className="text-muted">N/A</span>;

  const viewedType = viewedUserType?.toLowerCase();

  // Case 1: Viewed user is NOT partner → always visible
  if (viewedType !== 'partner') {
    return options.link ? (
      <a
        href={options.link}
        className={options.className}
        onClick={(e) => e.stopPropagation()}
      >
        {options.icon}
        {value}
      </a>
    ) : (
      <span>{value}</span>
    );
  }

  // Case 2: Viewed user IS partner
  // Only partner + active plan can see
  if (loggedInUserType === 'partner' && hasActivePlan) {
    return options.link ? (
      <a
        href={options.link}
        className={options.className}
        onClick={(e) => e.stopPropagation()}
      >
        {options.icon}
        {value}
      </a>
    ) : (
      <span>{value}</span>
    );
  }

  // All other cases → hide / blur
  return (
    <div className="d-flex flex-column align-items-start">
      <span style={{ filter: 'blur(3px)', userSelect: 'none' }}>
        {value}
      </span>
      <small className="text-muted">
        Only partners with active plan can view
      </small>
    </div>
  );
};


  const filteredUsers = useMemo(() => {
    return sortedUsers.filter((user) => {

      if (filters.name && !user.name?.toLowerCase().includes(filters.name.toLowerCase())) {
        return false;
      }

      if (filters.userType && user.user_type?.toLowerCase() !== filters.userType.toLowerCase()) {
        return false;
      }

      if (filters.contact_no && !user.contact_no?.includes(filters.contact_no)) {
        return false;
      }

      if (filters.city && !user.city?.toLowerCase().includes(filters.city.toLowerCase())) {
        return false;
      }

      if (filters.state && !user.state?.toLowerCase().includes(filters.state.toLowerCase())) {
        return false;
      }

      if (filters.pincode && !user.pincode?.toString().includes(filters.pincode)) {
        return false;
      }

      if (filters.parent_category_id && user.parent_category_id != filters.parent_category_id) {
        return false;
      }

      if (filters.child_category_id && user.child_category_id != filters.child_category_id) {
        return false;
      }

      if (filters.subchild_category_id && user.subchild_category_id != filters.subchild_category_id) {
        return false;
      }

      if (filters.status && user.status?.toString() !== filters.status.toString()) {
        return false;
      }

      return true;
    });
  }, [sortedUsers, filters]);

  const handleUserClick = (user) => {
    navigate(`/user-details/${user.user_id}`, { state: { user } });
  };

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <span className="ms-2" style={{ opacity: 0.3 }}>⇅</span>;
    }

    return (
      <span className="ms-2">
        {sortConfig.direction === 'asc' ? '↑' : '↓'}
      </span>
    );
  };

  return (
    <div className="user-list-page">
      <Helmet>
        <title>All Users</title>
      </Helmet>

      <Navbar />
      {/* {userss.user_type} */}
      <section className="section-padding section-bg">
        <div className="container">

          {/* ====================== FILTER PANEL ====================== */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-dark text-white">
              <h5 className="mb-0">Filter Users</h5>
            </div>

            <div className="card-body">
              <div className="row g-3">

                {/* NAME */}
                <div className="col-md-4">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.name}
                    onChange={(e) => handleFilterChange("name", e.target.value)}
                    placeholder="Search by name"
                  />
                </div>

                {/* USER TYPE */}
                <div className="col-md-4">
                  <label className="form-label">User Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.userType}
                    onChange={(e) => handleFilterChange("userType", e.target.value)}
                    placeholder="Business, Employee etc."
                  />
                </div>

                {/* CONTACT */}
                <div className="col-md-4">
                  <label className="form-label">Mobile No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.contact_no}
                    onChange={(e) => handleFilterChange("contact_no", e.target.value)}
                    placeholder="Search by phone"
                  />
                </div>

                {/* CITY */}
                <div className="col-md-4">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.city}
                    onChange={(e) => handleFilterChange("city", e.target.value)}
                    placeholder="Search by city"
                  />
                </div>

                {/* STATE */}
                <div className="col-md-4">
                  <label className="form-label">State</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.state}
                    onChange={(e) => handleFilterChange("state", e.target.value)}
                    placeholder="Search by state"
                  />
                </div>

                {/* PINCODE */}
                <div className="col-md-4">
                  <label className="form-label">Pincode</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.pincode}
                    onChange={(e) => handleFilterChange("pincode", e.target.value)}
                    placeholder="Search by pincode"
                  />
                </div>

                {/* PARENT CATEGORY */}
                <div className="col-md-4">
                  <label className="form-label">Parent Category</label>
                  <select
                    className="form-select"
                    value={filters.parent_category_id}
                    onChange={(e) => handleFilterChange("parent_category_id", e.target.value)}
                    style={{
                      width: "100%",
                      height: "40px",
                      border: "1px solid #c3bdbd66",
                      borderRadius: "3px",
                    }}
                  >
                    <option value="">All</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* CHILD CATEGORY */}
                <div className="col-md-4">
                  <label className="form-label">Child Category</label>
                  <select
                    className="form-select"
                    value={filters.child_category_id}
                    onChange={(e) => handleFilterChange("child_category_id", e.target.value)}
                    style={{
                      width: "100%",
                      height: "40px",
                      border: "1px solid #c3bdbd66",
                      borderRadius: "3px",
                    }}
                  >
                    <option value="">All</option>
                    {childCategories
                      .filter(c => c.parent_category_id == filters.parent_category_id)
                      .map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                  </select>
                </div>

                {/* SUBCHILD CATEGORY */}
                <div className="col-md-4">
                  <label className="form-label">Subchild Category</label>
                  <select
                    className="form-select"
                    value={filters.subchild_category_id}
                    onChange={(e) => handleFilterChange("subchild_category_id", e.target.value)}
                    style={{
                      width: "100%",
                      height: "40px",
                      border: "1px solid #c3bdbd66",
                      borderRadius: "3px",
                    }}
                  >
                    <option value="">All</option>
                    {subchildCategories
                      .filter(c => c.child_category_id == filters.child_category_id)
                      .map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                  </select>
                </div>

                {/* STATUS */}
                <div className="col-md-4">
                  <label className="form-label">Status</label>
                  <select
                    className="form-select"
                    value={filters.status}
                    onChange={(e) => handleFilterChange("status", e.target.value)}
                    style={{
                      width: "100%",
                      height: "40px",
                      border: "1px solid #c3bdbd66",
                      borderRadius: "3px",
                    }}
                  >
                    <option value="">All</option>
                    <option value="approved">Approved</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div className="col-md-4">
                  &nbsp;
                </div>
                <div className="col-md-4">
                  <div className="mt-3 text-end">
                    <button className="btn btn-primary me-2" onClick={handleApplyFilters}>
                      Apply Filters
                    </button>
                    <button className="btn btn-secondary" onClick={handleResetFilters}>
                      Reset
                    </button>
                  </div>
                </div>
              </div>


            </div>
          </div>

          {/* ====================== USER TABLE ====================== */}
          <div className="row">
            {loading ? (
              <div className="col-12 text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="col-12 text-center py-5">
                <div className="alert alert-danger">{error}</div>
                <button
                  onClick={() => window.location.reload()}
                  className="btn btn-primary mt-2"
                >
                  Try Again
                </button>
              </div>
            ) : filteredUsers.length > 0 ? (
              <div className="col-12">
                <div className="card shadow-sm">
                  <div className="card-header bg-light">
                    <h5 className="mb-0">
                      <i className="las la-users me-2 m-2"></i>
                      Users List ({filteredUsers.length} users found)
                    </h5>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover table-striped mb-0">
                        <thead className="table-dark">
                          <tr>
                            <th style={{ width: '80px' }}>Photo</th>
                            <th style={{ minWidth: '200px' }}>
                              <button
                                onClick={() => handleSort('name')}
                                className="btn btn-link text-white text-decoration-none p-0 border-0"
                              >
                                Name <SortIcon columnKey="name" />
                              </button>
                            </th>
                            <th style={{ minWidth: '150px' }}>
                              <button
                                onClick={() => handleSort('user_type')}
                                className="btn btn-link text-white text-decoration-none p-0 border-0"
                              >
                                User Type <SortIcon columnKey="user_type" />
                              </button>
                            </th>
                            <th style={{ minWidth: '150px' }}>
                              <button
                                onClick={() => handleSort('contact_no')}
                                className="btn btn-link text-white text-decoration-none p-0 border-0"
                              >
                                Mobile <SortIcon columnKey="contact_no" />
                              </button>
                            </th>
                            <th style={{ minWidth: '120px' }}>City</th>
                            <th style={{ minWidth: '120px' }}>State</th>
                            <th style={{ minWidth: '120px' }}>Pincode</th>
                            <th style={{ minWidth: '120px' }}>Category</th>
                            <th style={{ minWidth: '100px' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredUsers.slice(0, displayCount).map((user) => (
                            <tr
                              key={user.user_id}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleUserClick(user)}
                              className="user-row"
                            >
                              <td>
                                <img
                                  src={
                                    user.profile_photo
                                      ? `https://www.startupbusinesspartners.com/uploads/profile-photos/${user.profile_photo}`
                                      : DEFAULT_IMAGE
                                  }
                                  alt={user.name}
                                  className="rounded-circle border"
                                  style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = DEFAULT_IMAGE;
                                  }}
                                />
                              </td>
                              <td>
                                <strong>{user.name}</strong>
                                {user.status === '0' && (
                                  <span className="badge bg-warning ms-2">Inactive</span>
                                )}
                              </td>
                              <td>
                                <span className="badge bg-info" style={{ color: 'white' }}>
                                  <i className="las la-user-tie me-1"></i>
                                  {/* {user.user_type} */}
                                  {user.user_type === "Business"
                                    ? "Business for Sell"
                                    : user.user_type === "Employee"
                                      ? "Skilled Business Employee"
                                      : user.user_type}{" "}

                                </span>
                              </td>
                        <td>
                            {renderProtectedValue(
                              user.contact_no,
                              user.user_type,
                              {
                                link: `tel:${user.contact_no}`,
                                className:
                                  'btn btn-outline-success btn-sm',
                                icon: (
                                  <i className="las la-phone me-1"></i>
                                ),
                              }
                            )}
                          </td>



                              <td>
                                {user.city ? (
                                  <span>
                                    <i className="las la-map-marker me-1"></i>
                                    {user.city}
                                  </span>
                                ) : (
                                  <span className="text-muted">N/A</span>
                                )}
                              </td>
                                <td>{user.state || 'N/A'}</td>
                          <td>{user.pincode || 'N/A'}</td>
                              <td>
                                <small>
                                  {user.parent_category_name || 'N/A'}
                                </small>
                              </td>
                              <td>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUserClick(user);
                                  }}
                                >
                                  <i className="las la-eye me-1"></i>
                                  View
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {displayCount < filteredUsers.length && (
                      <div className="text-center py-3 text-muted">
                        Loading more users...
                      </div>
                    )}
                  </div>
                </div>

                {filteredUsers.length === 0 && (
                  <div className="alert alert-info text-center mt-3">
                    No users match your filter criteria.
                  </div>
                )}
              </div>
            ) : (
              <div className="col-12 text-center py-5">
                <div className="alert alert-info">
                  <i className="las la-users fs-1 mb-3 d-block"></i>
                  No users found.
                </div>
              </div>
            )}
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UserList;
